import { distinctUntilChanged } from 'rxjs';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, Output } from '@angular/core';
import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { type AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-design-form-control-input-route-input-text',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './route-input-text.input.form-control.design.html',
    styleUrls: ['./route-input-text.input.form-control.design.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    host: { class: 'w-full' },
    standalone: false
})
export class RouteInputTextInputFormControlDesign implements OnInit, OnChanges {
  @Input({ required: true }) set title(value: string) {
    this.#title = FlatFacades.NodeEntityFacade.getRouteString(value);
  }
  get title() {
    return this.#title;
  }
  @Input({ required: true }) control!: AbstractControl;
  @Input() inputClass: FlatModels.TextDesignModels.TextDesignClass = FlatModels.TextDesignModels.TextDesignClass.DEFAULT;
  @Output() valueChange = new EventEmitter<Event>();
  @Output() valueReset = new EventEmitter<Event>();
  
  #title: string;
  name: string | null = null;
  readonly FlatModels = FlatModels;
  
  constructor(private cd: ChangeDetectorRef, private destroyRef: DestroyRef) {
  }

  ngOnInit() {
    const formGroup = this.control.parent;
    if (formGroup) {
      this.name = Object.keys(formGroup.controls).find(name => this.control === formGroup.get(name)) || null;
    }

    if (this.name === null) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.form_control_name_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatDesign.RouteInputTextInputFormControlDesign.ngOnInit"
      );
    }
    
    this.control?.statusChanges.pipe(takeUntilDestroyed(this.destroyRef), distinctUntilChanged()).subscribe(() => {
      this.cd.markForCheck();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']?.currentValue) {
      this.control?.disable();
    } else {
      this.control?.enable();
    }
  }
}
